<template>
  <div>
    <el-drawer
      title="通知"
      :visible.sync="drawer"
      direction="rtl"
      size="500px"
      :modal="false"
      :before-close="handleClose"
    >
      <div
        class="notify-container"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <!-- 类型筛选和操作按钮 -->
        <div class="filter-container">
          <div class="filter-row">
            <dict-select
              v-model="queryParams.type"
              dict-type="notify_type"
              placeholder="请选择类型"
              style="flex: 1"
              @change="handleTypeChange"
            />
            <el-button
              type="primary"
              size="small"
              icon="el-icon-check"
              :loading="readAllLoading"
              @click="handleReadAll"
            >
              一键已读
            </el-button>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              :loading="deleteLoading"
              @click="handleDeleteRead"
            >
              删除全部已读
            </el-button>
          </div>
        </div>

        <!-- 通知列表 -->
        <div
          ref="notifyList"
          v-loading="loading"
          class="notify-list"
          @wheel="handleWheel"
        >
          <!-- 空状态 -->
          <div v-if="!loading && notifyList.length === 0" class="empty-state">
            <i class="el-icon-bell" />
            <p>暂无通知</p>
          </div>

          <!-- 通知卡片列表 -->
          <div v-else class="notify-cards">
            <div
              v-for="(item, index) in notifyList"
              :key="item.id || index"
              class="notify-card"
              :class="{'unread': item.isRead === '0'}"
              @click="handleCardClick(item)"
            >
              <!-- 未读标识 -->
              <div v-if="item.isRead === '0'" class="unread-indicator" />

              <div class="card-content">
                <!-- 标题和类型 -->
                <div class="card-header">
                  <h3 class="card-title" :class="{'unread-title': item.isRead === '0'}">
                    {{ item.title }}
                  </h3>
                  <dict-text v-model="item.type" dict-type="notify_type" :color-mode="false" style="display: inline-block" />
                </div>

                <!-- 发送人和时间 -->
                <div class="card-meta">
                  <div class="meta-item">
                    <i class="el-icon-user" />
                    <span>{{ item.senderName || '系统' }}</span>
                  </div>
                  <div class="meta-item">
                    <i class="el-icon-time" />
                    <span>{{ item.createTime }}</span>
                  </div>
                </div>

                <!-- 状态标签和操作按钮 -->
                <div class="card-footer">
                  <el-tag
                    :type="item.isRead === '1' ? 'success' : 'warning'"
                    size="mini"
                    class="status-tag"
                  >
                    {{ item.isRead === '1' ? '已读' : '未读' }}
                  </el-tag>
                  <div class="action-buttons">
                    <el-button
                      type="text"
                      size="mini"
                      icon="el-icon-view"
                      class="detail-btn"
                      @click.stop="handleViewDetail(item)"
                    >
                      详情
                    </el-button>
                    <el-button
                      type="text"
                      size="mini"
                      icon="el-icon-delete"
                      class="delete-btn"
                      @click.stop="handleDeleteNotify(item)"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
          <custom-pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </el-drawer>

    <!-- 通知详情弹框 -->
    <el-dialog
      title="通知详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleDetailDialogClose"
    >
      <div v-loading="detailLoading" class="detail-content">
        <div v-if="detailData" class="detail-info">
          <div class="detail-item">
            <div class="detail-label">
              通知标题：
            </div>
            <div class="detail-value">
              {{ detailData.title }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">
              发送人：
            </div>
            <div class="detail-value">
              {{ detailData.senderName || '系统' }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">
              通知类型：
            </div>
            <div class="detail-value">
              <dict-text v-model="detailData.type" dict-type="notify_type" style="display: inline-block" />
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">
              状态：
            </div>
            <div class="detail-value">
              <el-tag
                :type="detailData.status === '0' ? 'success' : 'danger'"
                size="small"
              >
                {{ detailData.status === '0' ? '成功' : '失败' }}
              </el-tag>
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">
              创建时间：
            </div>
            <div class="detail-value">
              {{ detailData.createTime }}
            </div>
          </div>
          <div class="detail-item detail-content-item">
            <div class="detail-label">
              通知内容：
            </div>
            <div class="detail-value content-text">
              {{ detailData.content || '暂无内容' }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {deleteNotify, deleteReadNotifications, getNotifyDetail, getNotifyPage, readAllNotifications} from "@/api/user";
import CustomPagination from "@/components/Commons/Pagination/index.vue";
import DictSelect from "@/components/Customs/DictSelect/index.vue";
import DictText from "@/components/Customs/DictText/index.vue";

export default {
    name: "NotifyPage",
    components: {
      DictText,
        CustomPagination,
        DictSelect
    },
    data() {
      return {
        drawer: false,
            loading: false,
            notifyList: [],
            total: 0,
            isMouseInDrawer: false, // 鼠标是否在抽屉内
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                isMine: "1", // 必需参数：我接收到的通知
                title: "",
                type: "",
                status: ""
            },
            // 详情弹框相关
            detailDialogVisible: false,
            detailLoading: false,
            detailData: null,
            // 删除相关
            deleteLoading: false,
            // 一键已读相关
            readAllLoading: false
        };
    },
    watch: {
        drawer(newVal) {
            if (newVal) {
                // 打开抽屉时加载数据
                this.getList();
            }
        }
    },
    methods: {
        /** 查询通知列表 */
        getList() {
            this.loading = true;
            getNotifyPage(this.queryParams)
                .then(response => {
                    this.notifyList = response.rows || [];
                    this.total = response.total || 0;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /** 类型筛选变化 */
        handleTypeChange() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 关闭抽屉 */
        handleClose() {
            this.drawer = false;
        },
        /** 点击卡片 */
        handleCardClick(item) {
            // 可以在这里添加点击卡片的处理逻辑，比如查看详情、标记已读等
            console.log('点击通知:', item);
        },
        /** 查看详情 */
        handleViewDetail(item) {
            this.detailDialogVisible = true;
            this.detailData = null;
            this.detailLoading = true;

            // 调用接口获取详情
            getNotifyDetail(item.id)
                .then(response => {
                    this.detailData = response.data || {};
                    this.detailLoading = false;
                })
                .catch(() => {
                    this.detailLoading = false;
                    this.$message.error('获取通知详情失败');
                });
        },
        /** 详情弹窗关闭 */
        handleDetailDialogClose() {
            // 关闭弹窗后刷新通知列表
            this.getList();
            // 刷新通知数量
            if (this.$parent && this.$parent.fetchNotifyCount) {
                this.$parent.fetchNotifyCount();
            }
        },
        /** 一键已读通知 */
        handleReadAll() {
            this.$confirm('确定要将所有通知标记为已读吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.readAllLoading = true;
                readAllNotifications()
                    .then(() => {
                        this.$message.success('操作成功');
                        // 刷新列表
                        this.getList();
                        // 刷新通知数量
                        if (this.$parent && this.$parent.fetchNotifyCount) {
                            this.$parent.fetchNotifyCount();
                        }
                        this.readAllLoading = false;
                    })
                    .catch(() => {
                        this.$message.error('操作失败');
                        this.readAllLoading = false;
                    });
            }).catch(() => {
                // 用户取消
            });
        },
        /** 删除已读通知 */
        handleDeleteRead() {
            this.$confirm('确定要删除所有已读通知吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteLoading = true;
                deleteReadNotifications()
                    .then(() => {
                        this.$message.success('删除成功');
                        // 刷新列表
                        this.getList();
                        // 刷新通知数量
                        if (this.$parent && this.$parent.fetchNotifyCount) {
                            this.$parent.fetchNotifyCount();
                        }
                        this.deleteLoading = false;
                    })
                    .catch(() => {
                        this.$message.error('删除失败');
                        this.deleteLoading = false;
                    });
            }).catch(() => {
                // 用户取消
            });
        },
        /** 删除单个通知 */
        handleDeleteNotify(item) {
            this.$confirm('确定要删除这条通知吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteNotify(item.id, this.queryParams.isMine)
                    .then(() => {
                        this.$message.success('删除成功');
                        // 刷新列表
                        this.getList();
                        // 刷新通知数量
                        if (this.$parent && this.$parent.fetchNotifyCount) {
                            this.$parent.fetchNotifyCount();
                        }
                    })
                    .catch(() => {
                        this.$message.error('删除失败');
                    });
            }).catch(() => {
                // 用户取消
            });
        },
        /** 鼠标进入抽屉 */
        handleMouseEnter() {
            this.isMouseInDrawer = true;
        },
        /** 鼠标离开抽屉 */
        handleMouseLeave() {
            this.isMouseInDrawer = false;
        },
        /** 处理滚动事件 */
        handleWheel(event) {
            if (!this.isMouseInDrawer) {
                return; // 鼠标不在抽屉内，允许正常滚动
            }

            const listElement = this.$refs.notifyList;
            if (!listElement) {
                return;
            }

            const { scrollTop, scrollHeight, clientHeight } = listElement;
            const isAtTop = scrollTop === 0;
            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1; // 允许1px误差

            // 向上滚动且已经在顶部，或者向下滚动且已经在底部
            if ((event.deltaY < 0 && isAtTop) || (event.deltaY > 0 && isAtBottom)) {
                // 阻止事件冒泡，防止页面滚动
                event.stopPropagation();
                // 阻止默认行为
                event.preventDefault();
            }
        }
    }
  };
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
    margin-bottom: 0;
}
.notify-container {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .filter-container {
        margin-bottom: 20px;
        padding: 15px;
        background: #f5f7fa;
        border-radius: 4px;

        .filter-row {
            display: flex;
            align-items: center;
            gap: 12px;
        }
    }

    .notify-list {
        flex: 1;
        overflow-y: auto;
        min-height: 0;
        overscroll-behavior: contain; // 防止滚动穿透
        -webkit-overflow-scrolling: touch; // iOS 平滑滚动

        // 当滚动到底部时，阻止继续滚动影响页面
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c0c4cc;
            border-radius: 3px;
        }
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        color: #909399;

        i {
            font-size: 48px;
            margin-bottom: 16px;
            color: #c0c4cc;
        }

        p {
            font-size: 14px;
            margin: 0;
        }
    }

    .notify-cards {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .notify-card {
        position: relative;
        background: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            transform: translateY(-2px);
            border-color: #409eff;
        }

        &.unread {
            background: #f0f9ff;
            border-left: 4px solid #409eff;
            border-color: #409eff;

            .unread-indicator {
                position: absolute;
                top: 16px;
                right: 16px;
                width: 8px;
                height: 8px;
                background: #f56c6c;
                border-radius: 50%;
            }
        }

        .card-content {
            position: relative;
        }

        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 12px;
            gap: 12px;

            .card-title {
                flex: 1;
                margin: 0;
                font-size: 16px;
                font-weight: 500;
                color: #303133;
                line-height: 1.5;
                word-break: break-word;

                &.unread-title {
                    font-weight: 600;
                    color: #303133;
                }
            }

            .type-tag {
                flex-shrink: 0;
            }
        }

        .card-meta {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-bottom: 12px;
            font-size: 13px;
            color: #909399;

            .meta-item {
                display: flex;
                align-items: center;
                gap: 4px;

                i {
                    font-size: 14px;
                }
            }
        }

        .card-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .status-tag {
                margin: 0;
            }

            .action-buttons {
                display: flex;
                align-items: center;
                gap: 8px;
            }

            .detail-btn,
            .delete-btn {
                padding: 0;
                color: #409eff;

                &:hover {
                    color: #66b1ff;
                }
            }

            .delete-btn {
                color: #f56c6c;

                &:hover {
                    color: #f78989;
                }
            }
        }
    }

    .pagination-container {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #e4e7ed;
        text-align: right;
    }
}

// 详情弹框样式
.detail-content {
    min-height: 200px;
}

.detail-info {
    .detail-item {
        display: flex;
        margin-bottom: 16px;
        line-height: 1.6;

        .detail-label {
            min-width: 100px;
            font-weight: 500;
            color: #606266;
        }

        .detail-value {
            flex: 1;
            color: #303133;
            word-break: break-word;
        }

        &.detail-content-item {
            flex-direction: column;

            .detail-label {
                margin-bottom: 8px;
            }

            .content-text {
                padding: 12px;
                background: #f5f7fa;
                border-radius: 4px;
                white-space: pre-wrap;
                line-height: 1.8;
            }
        }
    }
}
</style>
